module.exports = __webpack_public_path__ + "static/media/3d-logo-heavily-left-small.ab517017.png";